<template>
  <div class="channel-financial">
    <!-- 页面头部 -->
<!--    <div class="page-header">-->
<!--      <div class="header-left">-->
<!--        <h2 class="page-title"><i class="el-icon-s-finance"></i> 渠道财务</h2>-->
<!--        <span class="page-desc">查看渠道佣金收支流水、财务概览及资金变动明细</span>-->
<!--      </div>-->
<!--      <div class="header-right">-->
<!--        <el-button icon="el-icon-refresh" size="small" @click="loadStatistics">刷新</el-button>-->
<!--      </div>-->
<!--    </div>-->

    <!-- 财务概览 -->
    <div class="section-title"><i class="el-icon-money"></i> 财务概览</div>
    <el-row :gutter="16" class="stat-row">
      <el-col :span="6">
        <div class="stat-card income" @click="filterByType(1)">
          <div class="stat-icon">
            <i class="el-icon-coin"></i>
          </div>
          <div class="stat-content">
            <div class="stat-label">佣金收入</div>
            <div class="stat-value">¥{{ statistics.commissionIncome | filterMoney }}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="stat-card expense" @click="filterByType(2)">
          <div class="stat-icon">
            <i class="el-icon-wallet"></i>
          </div>
          <div class="stat-content">
            <div class="stat-label">提现支出</div>
            <div class="stat-value">¥{{ statistics.withdrawalExpense | filterMoney }}</div>
          </div>
        </div>
      </el-col>
      <!-- <el-col :span="6">
        <div class="stat-card deduct" @click="filterByType(2)">
          <div class="stat-icon">
            <i class="el-icon-minus"></i>
          </div>
          <div class="stat-content">
            <div class="stat-label">佣金扣除</div>
            <div class="stat-value">¥{{ statistics.commissionDeduct | filterMoney }}</div>
          </div>
        </div>
      </el-col> -->
      <el-col :span="6">
        <div class="stat-card balance">
          <div class="stat-icon">
            <i class="el-icon-data-analysis"></i>
          </div>
          <div class="stat-content">
            <div class="stat-label">净收入</div>
            <div class="stat-value">¥{{ statistics.netIncome | filterMoney }}</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 筛选栏 -->
    <div class="filter-bar">
      <el-radio-group v-model="searchForm.type" @change="handleSearch">
        <el-radio-button label="">全部</el-radio-button>
        <el-radio-button
          v-for="item in flowTypeOptions"
          :key="item.value"
          :label="item.value">
          {{ item.label }}
        </el-radio-button>
      </el-radio-group>
      <el-button icon="el-icon-refresh" @click="refreshList">刷新</el-button>
    </div>

    <!-- 列表 -->
    <custom-table
      ref="customTable"
      has-organization="true"
      :customOptions="customOptions"
      :columns="columns"
      :excel-type="btnPreFn('channel_flow_export', false) ? 'ChannelFinance' : ''">
      <template slot-scope="{item, row}">
        <template v-if="item.prop === 'financeNo'">
          <div class="flow-no-cell">
            <span class="flow-no" @dblclick="$utils.copyText(row.financeNo)">{{ row.financeNo }}</span>
            <i class="el-icon-document-copy copy-icon" @click="$utils.copyText(row.financeNo)"></i>
          </div>
        </template>
        <template v-else-if="item.prop === 'channelInfo'">
          <div class="channel-cell">
            <span class="channel-name">{{ row.channelName }}</span>
            <span class="channel-no">{{ row.channelNo }}</span>
          </div>
        </template>
        <template v-else-if="item.prop === 'type'">
          <el-tag :type="getFlowType(row.type)" size="small">
            {{ row.type | filterConst('CHANNEL_FLOW_TYPE') }}
          </el-tag>
        </template>
        <template v-else-if="item.prop === 'amount'">
          <span class="amount-cell" :class="row.amount > 0 ? 'income' : 'expense'">
           ¥ {{ row.amount | filterMoney }}
          </span>
        </template>
        <template v-else-if="item.prop === 'balance'">
          <span class="balance-value">¥{{ row.balance | filterMoney }}</span>
        </template>
        <template v-else-if="item.prop === 'relatedType'">
          <el-tag size="mini" type="info">{{ row.relatedType | filterConst('CHANNEL_FLOW_REF_TYPE') }}</el-tag>
        </template>
        <template v-else-if="item.prop === 'relatedNo'">
          <span v-if="row.relatedType === 1" class="ref-link" @click="viewOrder(row)">
            <i class="el-icon-document"></i>{{ row.relatedNo }}
          </span>
          <span v-else-if="row.relatedType === 2" class="ref-link withdrawal" @click="viewWithdrawal(row)">
            <i class="el-icon-wallet"></i>{{ row.relatedNo }}
          </span>
          <span v-else-if="row.relatedType === 3" class="ref-link recharge" @click="viewRecharge(row)">
            <i class="el-icon-coin"></i>{{ row.relatedNo }}
          </span>
          <span v-else class="text-muted">-</span>
        </template>
        <template v-else-if="item.prop === 'created'">
          {{ row.created | filterTime }}
        </template>
        <template v-else>
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] || '-' }}</span>
        </template>
      </template>
    </custom-table>

    <!-- 订单详情抽屉 -->
    <order-detail-drawer
      :visible.sync="orderDrawerVisible"
      :order-id="currentOrderId"
      caller-type="financial"
      @go-to-channel="goToChannel">
    </order-detail-drawer>

    <!-- 提现详情对话框 -->
    <withdrawal-detail-dialog
      :visible.sync="withdrawalDialogVisible"
      :withdrawal-id="currentWithdrawalId"
      :type="currentWithdrawalType">
    </withdrawal-detail-dialog>

    <!-- 充值详情对话框 -->
    <recharge-detail-dialog
      :visible.sync="rechargeDialogVisible"
      :recharge-id="currentRechargeId">
    </recharge-detail-dialog>

  </div>
</template>

<script>
import OrderDetailDrawer from '../order/components/orderDetailDrawer.vue'
import WithdrawalDetailDialog from '../withdrawal/components/withdrawalDetailDialog.vue'
import RechargeDetailDialog from '../withdrawal/components/rechargeDetailDialog.vue'

export default {
  name: 'channelFinancial',
  components: {
    OrderDetailDrawer,
    WithdrawalDetailDialog,
    RechargeDetailDialog
  },
  data() {
    return {
      statistics: {
        commissionIncome: 0,
        withdrawalExpense: 0,
        netIncome: 0
      },
      searchForm: {
        type: ''
      },
      customOptions: {
        url: '/api/v1/channel/finance/list',
        method: 'get',
        params: {},
        search: [
          { type: 'input', field: 'keyword', name: '关键词', value: '' },
          { type: 'daytime', field: 'Time', name: '时间范围', value: '', clearable: true, dateProp: { start: 'startTime', end: 'endTime' } }
        ]
      },
      columns: [
        { label: '流水号', prop: 'financeNo', minWidth: 160, align: 'left' },
        { label: '渠道信息', prop: 'channelInfo', minWidth: 150, align: 'left' },
        { label: '流水类型', prop: 'type', minWidth: 100, align: 'left' },
        { label: '金额', prop: 'amount', minWidth: 120, align: 'left' },
        { label: '余额', prop: 'balance', minWidth: 120, align: 'left' },
        { label: '关联类型', prop: 'relatedType', minWidth: 100, align: 'left' },
        { label: '关联单号', prop: 'relatedNo', minWidth: 160, align: 'left' },
        { label: '备注', prop: 'remark', minWidth: 150, align: 'left' },
        { label: '创建时间', prop: 'created', minWidth: 160, align: 'left' }
      ],
      // 订单详情抽屉
      orderDrawerVisible: false,
      currentOrderId: null,
      // 提现详情对话框
      withdrawalDialogVisible: false,
      currentWithdrawalId: null,
      currentWithdrawalType: null,
      // 充值详情对话框
      rechargeDialogVisible: false,
      currentRechargeId: null
    }
  },
  computed: {

    flowTypeOptions() {
      return this.$const.CHANNEL_FLOW_TYPE || []
    }
  },
  mounted() {
    this.$refs.customTable.getList()
    this.loadStatistics()
  },
  methods: {
    handleSearch() {
      this.customOptions.params.type = this.searchForm.type
      if (this.$refs.customTable) {
        this.$refs.customTable.getList()
      }
    },
    refreshList() {
      if (this.$refs.customTable) {
        this.$refs.customTable.getList()
      }
      this.loadStatistics()
    },
    filterByType(type) {
      this.searchForm.type = type
      this.handleSearch()
    },
    // 查看订单详情
    viewOrder(row) {
      this.currentOrderId = row.relatedId
      this.orderDrawerVisible = true
    },
    // 查看提现详情
    viewWithdrawal(row) {
      this.currentWithdrawalId = row.relatedId
      this.currentWithdrawalType = row.relatedType
      this.withdrawalDialogVisible = true
    },
    // 查看充值详情
    viewRecharge(row) {
      this.currentRechargeId = row.relatedId
      this.rechargeDialogVisible = true
    },
    // 跳转到渠道详情
    goToChannel(orderData) {
      const channelId = orderData.channelId || orderData
      this.$router.push({
        path: '/channelDetail',
        query: { id: channelId }
      })
    },
    getFlowType(type) {
      const typeItem = this.$const.CHANNEL_FLOW_TYPE.find(i => i.value === type)
      return typeItem ? typeItem.type : ''
    },
    /**
     * 获取财务统计
     * 使用接口：GET /api/v1/channel/finance/statistics
     * 作者：孙艺
     */
    async loadStatistics() {
      try {
        const res = await this.$axios.get('/api/v1/channel/finance/statistics', {})
        if (res && res.code === 1 && res.data) {
          this.statistics = {
            commissionIncome: res.data.commissionIncome || 0,
            withdrawalExpense: res.data.withdrawalExpense || 0,
            netIncome: res.data.netIncome || 0
          }
        }
      } catch (error) {
        console.error('获取财务统计失败:', error)
        this.$message.error('获取财务统计失败')
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../channel.less';

// 页面容器
.channel-financial {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

// 列表单元格样式
.flow-no-cell {
  display: flex;
  align-items: center;

  .flow-no {
    font-family: monospace;
  }

  .copy-icon {
    margin-left: 6px;
    color: #C0C4CC;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.2s;

    &:hover { color: #409EFF; }
  }

  &:hover .copy-icon {
    opacity: 1;
  }
}

.channel-cell {
  .channel-name {
    display: block;
    font-weight: 500;
    color: #303133;
  }
  .channel-no {
    font-size: 12px;
    color: #909399;
  }
}

.amount-cell {
  font-weight: 600;

  &.income { color: #67C23A; }
  &.expense { color: #F56C6C; }
}

.balance-value {
  color: #606266;
}

.ref-link {
  color: #409EFF;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;

  &:hover {
    text-decoration: underline;
  }

  &.withdrawal {
    color: #E6A23C;
  }
  
  &.recharge {
    color: #67C23A;
  }
}

.text-muted {
  color: #C0C4CC;
}

// 抽屉样式
/deep/ .financial-drawer {
  .el-drawer__header {
    margin-bottom: 0;
    padding: 16px 20px;
    border-bottom: 1px solid #EBEEF5;
  }

  .el-drawer__body {
    padding: 0;
    display: flex;
    flex-direction: column;
    height: calc(100% - 60px);
  }
}

.drawer-content {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 80px;
}

// 状态栏
.drawer-status-bar {
  padding: 16px 20px;

  &.order {
    background: linear-gradient(135deg, #67C23A15 0%, #67C23A08 100%);
    border-bottom: 2px solid #67C23A;
  }

  &.withdrawal {
    &.pending {
      background: linear-gradient(135deg, #E6A23C15 0%, #E6A23C08 100%);
      border-bottom: 2px solid #E6A23C;
    }
    &.success {
      background: linear-gradient(135deg, #67C23A15 0%, #67C23A08 100%);
      border-bottom: 2px solid #67C23A;
    }
    &.rejected {
      background: linear-gradient(135deg, #F56C6C15 0%, #F56C6C08 100%);
      border-bottom: 2px solid #F56C6C;
    }
  }

  .status-main {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 6px;

    .ref-no-text {
      font-size: 14px;
      font-weight: 500;
      color: #303133;
      font-family: monospace;
    }
  }

  .status-desc {
    font-size: 13px;
    color: #909399;
  }
}

// 金额区域
.amount-section {
  padding: 16px 20px !important;
  border-bottom: none !important;

  .amount-overview {
    padding: 20px;
    background: linear-gradient(135deg, #67C23A10 0%, #67C23A05 100%);
    border-radius: 8px;
    border: 1px solid #67C23A30;
    text-align: center;

    .amount-main {
      margin-bottom: 12px;

      .amount-label {
        font-size: 13px;
        color: #909399;
        display: block;
        margin-bottom: 8px;
      }

      .amount-value {
        font-size: 32px;
        font-weight: 700;

        &.income { color: #67C23A; }
      }
    }

    .amount-detail {
      font-size: 13px;
      color: #606266;

      .separator {
        margin: 0 12px;
        color: #DCDFE6;
      }
    }
  }

  .withdrawal-amount-card {
    padding: 20px;
    background: linear-gradient(135deg, #f5f7fa 0%, #fff 100%);
    border-radius: 8px;
    border: 1px solid #EBEEF5;

    .amount-row {
      display: flex;
      align-items: center;
      justify-content: center;

      .amount-item {
        text-align: center;
        padding: 0 16px;

        &.highlight {
          background: #67C23A10;
          padding: 12px 20px;
          border-radius: 8px;
        }

        .amount-label {
          font-size: 12px;
          color: #909399;
          display: block;
          margin-bottom: 6px;
        }

        .amount-value {
          font-size: 20px;
          font-weight: 600;
          color: #303133;

          &.fee { color: #F56C6C; }
          &.actual { color: #67C23A; font-size: 24px; }
        }
      }

      .amount-arrow {
        padding: 0 12px;
        color: #C0C4CC;

        i { font-size: 16px; }
      }
    }
  }
}

// 抽屉区块
.drawer-section {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;

  .section-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
    font-size: 15px;
    font-weight: 600;
    color: #303133;

    i { color: #409EFF; }

    .el-button {
      margin-left: auto;
    }
  }
}

// 信息网格
.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;

  .info-item {
    display: flex;
    flex-direction: column;
    padding: 10px 12px;
    background: #fafafa;
    border-radius: 6px;

    .info-label {
      font-size: 12px;
      color: #909399;
      margin-bottom: 4px;
    }

    .info-value {
      font-size: 14px;
      color: #303133;
      display: flex;
      align-items: center;

      &.highlight {
        font-weight: 600;
        color: #409EFF;
      }
    }
  }
}

// 渠道信息卡片
.channel-info-card {
  display: flex;
  align-items: center;
  padding: 16px;
  background: #fafafa;
  border-radius: 8px;

  .channel-avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;

    i {
      font-size: 24px;
      color: #fff;
    }
  }

  .channel-detail {
    .channel-name {
      font-size: 15px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 4px;
    }

    .channel-meta {
      display: flex;
      align-items: center;

      .channel-no {
        font-size: 13px;
        color: #909399;
      }
    }
  }
}

// 佣金计算卡片
.commission-calc-card {
  padding: 20px;
  background: linear-gradient(135deg, #67C23A10 0%, #67C23A05 100%);
  border-radius: 8px;
  border: 1px dashed #67C23A50;
  text-align: center;

  .calc-formula {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-bottom: 12px;

    .calc-item {
      font-size: 18px;
      color: #606266;
    }

    .calc-symbol {
      font-size: 16px;
      color: #909399;
    }

    .calc-result {
      font-size: 24px;
      font-weight: 700;
      color: #67C23A;
    }
  }

  .calc-desc {
    font-size: 12px;
    color: #909399;
  }
}

// 收款账户卡片
.account-card {
  display: flex;
  align-items: center;
  padding: 16px;
  border-radius: 8px;

  &.alipay {
    background: linear-gradient(135deg, #1677FF10 0%, #1677FF05 100%);
    border: 1px solid #1677FF30;
  }

  .account-icon {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    background: linear-gradient(135deg, #1677FF 0%, #4096ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;

    i {
      font-size: 24px;
      color: #fff;
    }
  }

  .account-info {
    flex: 1;

    .account-type {
      font-size: 12px;
      color: #909399;
      margin-bottom: 4px;
    }

    .account-detail {
      .account-name {
        font-size: 15px;
        font-weight: 600;
        color: #303133;
        margin-right: 12px;
      }

      .account-no {
        font-size: 14px;
        color: #606266;
      }
    }
  }
}

// 时间线
.timeline {
  position: relative;
  padding-left: 24px;

  &::before {
    content: '';
    position: absolute;
    left: 7px;
    top: 8px;
    bottom: 8px;
    width: 2px;
    background: #E4E7ED;
  }

  .timeline-item {
    position: relative;
    padding-bottom: 20px;

    &:last-child {
      padding-bottom: 0;
    }

    .timeline-dot {
      position: absolute;
      left: -24px;
      top: 4px;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: #fff;
      border: 2px solid #E4E7ED;
      z-index: 1;
    }

    &.active .timeline-dot {
      background: #409EFF;
      border-color: #409EFF;
    }

    &.success.active .timeline-dot {
      background: #67C23A;
      border-color: #67C23A;
    }

    .timeline-content {
      .timeline-title {
        font-size: 14px;
        font-weight: 500;
        color: #303133;
        margin-bottom: 4px;
      }

      .timeline-time {
        font-size: 12px;
        color: #909399;
      }
    }
  }
}

// 备注内容
.remark-content {
  padding: 12px 16px;
  background: #fafafa;
  border-radius: 6px;
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
}

// 抽屉底部
.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px 20px;
  background: #fff;
  border-top: 1px solid #EBEEF5;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
</style>
